export const ele = function (id) {
  return document.getElementById(id)
}



// WEBPACK FOOTER //
// ./src/helper/gen.js